import { Box, ButtonBase, Collapse, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import useToggle from "minimals-template/components/@hooks/useToggle"

export function CollapsibleSearchSection({ title, defaultOpen = true, collapsible = true, sx, children }) {
    const { toggle: open, onToggle } = useToggle(defaultOpen)
    const expanded = collapsible ? open : true

    return (
        <Box sx={{ mb: collapsible ? 2 : 4, ...sx }}>
            <If value={collapsible}>
                <ButtonBase
                    type="button"
                    onClick={onToggle}
                    aria-expanded={expanded}
                    sx={{ borderRadius: 1, mb: expanded ? 1.5 : 0, userSelect: "none" }}
                >
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <Iconify
                            icon={expanded ? "eva:chevron-down-fill" : "eva:chevron-right-fill"}
                            width={22}
                            height={22}
                        />
                        <Typography variant="subtitle1" sx={{ color: "text.primary", fontWeight: 600 }}>
                            {title}
                        </Typography>
                    </Stack>
                </ButtonBase>
                <Else>
                    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 2, userSelect: "none" }}>
                        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
                            {title}
                        </Typography>
                    </Stack>
                </Else>
            </If>
            <Collapse in={expanded}>{children}</Collapse>
        </Box>
    )
}
